import { render, staticRenderFns } from "./RadioComponent.vue?vue&type=template&id=8cfd76b4&scoped=true"
import script from "./RadioComponent.vue?vue&type=script&lang=js"
export * from "./RadioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfd76b4",
  null
  
)

export default component.exports